<form
  [formGroup]="form"
  (ngSubmit)="savePassword()"
  class="form-container container-fluid"
>
  <div class="row justify-content-center">
    <div class="col-lg-4 col-md-8 col-12">
      <mat-card
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        "
      >
        <mat-card-content>
          <div class="row">
            <!-- Logo Section -->
            <div
              class="col-12 text-center"
              style="display: flex; flex-direction: column; align-items: center"
            >
              <img src="assets/img/logo.png" alt="logo" class="img-fluid" />
              <img
                class="img-fluid"
                style="height: 45px; transform: translateY(-10px)"
                src="assets/img/pulselogo.png"
                alt="Pulse Logo"
              />
            </div>

            <!-- Username Field -->
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "UserName/صارف کا نام" | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="{{ 'UserName/صارف کا نام' | translate }}"
                  formControlName="userName"
                  [disabled]="resendTimer > 0"
                />
                <mat-error *ngIf="f['userName'].errors?.['required']">
                  {{ "USER_NAME_REQUIRED" | translate }}
                </mat-error>
                <mat-error *ngIf="f['userName'].errors?.['maxlength']">
                  {{ "MAXLENGTH_30" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Send OTP Button -->
            <!-- <div class="col-12 mt-3">
              <button
                mat-raised-button
                color="primary"
                [disabled]="f['userName'].invalid"
                class="w-100"
                (click)="sendCode()"
                type="button"
              >
                {{ "SEND_OTP" | translate }}
              </button>
            </div> -->

            <div class="col-12 mt-3">
              <button
                style="
                  display: flex;
                  justify-content: center;
                  width: 100%;
                  margin: auto;
                  align-items: center;
                  text-align: center;
                "
                mat-raised-button
                color="primary"
                [disabled]="f['userName'].invalid || resendTimer > 0"
                (click)="sendCode()"
                type="button"
              >
                {{ retryActive ? "Resend OTP" : "Send OTP" }}
              </button>
              <div
                *ngIf="resendTimer > 0"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  margin-top: 2%;
                "
              >
                {{ "Resend request in:" | translate }} (<span
                  class="text-danger"
                  >{{ formattedTimer + "s" }}</span
                >)
              </div>
            </div>

            <!-- Divider -->
            <div class="col-12 mt-3">
              <hr />
            </div>

            <!-- OTP Field -->
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "OTP" | translate }}</mat-label>
                <input
                  matInput
                  type="number"
                  placeholder="{{ 'OTP' | translate }}"
                  formControlName="otp"
                  maxlength="6"
                  (input)="onOtpInput($event)"
                />
                <mat-error *ngIf="f['otp'].errors?.['required']">
                  {{ "OTP_REQUIRED" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Password Field -->
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ "Password/پاس ورڈ" | translate }}</mat-label>
                <input
                  matInput
                  type="password"
                  placeholder="{{ 'Password/پاس ورڈ' | translate }}"
                  formControlName="password"
                />
              </mat-form-field>
              <div style="transform: translateY(-20px)">
                <mat-error
                  *ngIf="f['password'].errors?.['required'] && f['password'].touched"
                >
                  {{ "PASSWORD_REQUIRED" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="f['password'].errors?.['minlength'] && f['password'].touched"
                >
                  {{ "Minimum length is 8 (e.g Test@1234)" | translate }}
                </mat-error>
                <mat-error *ngIf="f['password'].errors?.['maxlength']">
                  {{ "MAX_LENGTH_30" | translate }}
                </mat-error>
                <mat-error *ngIf="f['password'].errors?.['pattern']">
                  <ul class="error-list">
                    <li>
                      {{
                        "Password must be alphanumeric/پاس ورڈ حروف عدوی ہونا چاہیے"
                          | translate
                      }}
                    </li>
                    <li>
                      {{
                        "Password must contain at least one capital letter/کم از کم ایک بڑا حرف ہونا چاہیے"
                          | translate
                      }}
                    </li>
                  </ul>
                </mat-error>
              </div>
            </div>
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{
                  "Confirm Password/پاس ورڈ کی تصدیق کریں" | translate
                }}</mat-label>
                <input
                  matInput
                  type="password"
                  placeholder="{{
                    'Confirm Password/پاس ورڈ کی تصدیق کریں' | translate
                  }}"
                  formControlName="confirmPassword"
                />
              </mat-form-field>
              <div style="transform: translateY(-20px)">
                <mat-error
                  *ngIf="f['confirmPassword'].errors?.['required'] && f['confirmPassword'].touched"
                >
                  {{ "PASSWORD_REQUIRED" | translate }}
                </mat-error>
                <mat-error
                  *ngIf="form.errors?.['matchPassword'] && f['confirmPassword'].touched"
                >
                  {{
                    "Passwords do not match/پاس ورڈ مماثل نہیں ہیں" | translate
                  }}
                </mat-error>
              </div>
            </div>

            <div class="col-12 mt-3">
              <button
                mat-raised-button
                color="primary"
                class="w-100"
                [disabled]="form.invalid"
                type="submit"
              >
                {{ "SAVE_NEW_PASSWORD" | translate }}
              </button>
              <a
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  margin: auto;
                "
                mat-button
                class="forgot-password-link text-secondary"
                [routerLink]="'/login'"
                >Login</a
              >
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</form>
